import './layout.scss'
import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header'
import './layout.scss'
import Akutrutan from '../Akutrutan/Akutrutan'
import { NewsSpinner } from '../NewsSpinner/NewsSpinner'
import Footer from '../Footer/Footer'

const Layout = ({ pageContext, children, className, logoSrc, extraClasses = '', homePath }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false)
  const [isAkutrutaActive, setIsAkutrutaActive] = useState(false)
  const [isSubMenuActive, setIsSubMenuActive] = useState(false)
  const layoutRef = useRef(null)

  useEffect(() => {
    const disableScroll = () => {
      const layout = layoutRef.current
      const body = layout.parentElement.parentElement.parentElement

      if (isAccordionOpen) {
        body.style.overflowY = 'hidden'
      } else {
        body.style.overflowY = 'scroll'
      }
    }

    disableScroll()
  }, [isAccordionOpen, layoutRef])

  return (
    <>
      <div ref={layoutRef} className={`layout ${extraClasses} ${className}`}>
        <div className="sticky-container">
          <Akutrutan setIsAkutrutaActive={setIsAkutrutaActive} />
          <Header
            setIsAccordionOpen={setIsAccordionOpen}
            setIsSubMenuActive={setIsSubMenuActive}
            isAkutrutaActive={isAkutrutaActive}
            logoSrc={logoSrc}
            homePath={homePath}
            pageContext={pageContext}
          />
        </div>
        {!isSubMenuActive && <NewsSpinner />}
        {children}
        <Footer logoSrc={logoSrc} />
      </div>
    </>
  )
}

export default Layout
